import { t } from "i18next";
import { useEffect, useRef, useState } from "react";

const CustomDocumentRenderer = ({ mainState: { currentDocument } }) => {
  const [iframeTimeoutId, setIframeTimeoutId] = useState(undefined);
  const iframeRef = useRef(null);

  // Update the iframe 'src' until the document is loaded
  useEffect(() => {
    const intervalId = setInterval(updateIframeSrc, 3000);
    setIframeTimeoutId(intervalId);
  }, []);

  if (!currentDocument) return null;

  const googleDocsViewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
    currentDocument.uri
  )}&embedded=true`;

  const updateIframeSrc = () => {
    if (iframeRef.current) {
      iframeRef.current.src = googleDocsViewerUrl;
    }
  };

  const iframeLoaded = () => {
    clearInterval(iframeTimeoutId);
  };

  return (
    <div style={{ width: "100%" }} id="my-doc-renderer">
      <iframe
        id="doc-viewer"
        title={t("documentViewer.documentViewer")}
        onLoad={iframeLoaded}
        className="doc"
        width="100%"
        height="100%"
        ref={iframeRef}
        src={googleDocsViewerUrl}
      ></iframe>
    </div>
  );
};

CustomDocumentRenderer.fileTypes = ["pdf", "doc", "docx"];
CustomDocumentRenderer.weight = 1;

export default CustomDocumentRenderer;
